export default __webpack_public_path__ + "static/media/dev.4007780e.png";